import { Button, Container, Typography } from '@cleartrip/ct-design-components'

import { ChevronRight } from '@/assets/icons/ChevronRight'

import { TUPLE_COLORS } from '../config/tupleTheme'

export type TupleActionsVariant = 'book' | 'details' | 'select' | 'continue'

export interface TupleActionsProps {
  disabled?: boolean
  detailsLabel?: string
  linkColor?: string
  onBook?: () => void
  onContinue?: () => void
  onFlightDetails?: () => void
  onSelect?: () => void
  size?: 'small' | 'medium'
  variant?: TupleActionsVariant
  withChevron?: boolean
}

const linkButtonClass = 'bn bg-transparent c-pointer p-0 flex-no-shrink flex flex-middle flex-cg-1'

const TupleActions: React.FC<TupleActionsProps> = ({
  disabled = false,
  detailsLabel = 'Flight details',
  linkColor,
  onBook,
  onContinue,
  onFlightDetails,
  onSelect,
  size = 'small',
  variant = 'book',
  withChevron = false,
}) => {
  if (variant === 'details') {
    const color = linkColor || TUPLE_COLORS.link
    return (
      <Container
        as='button'
        className={linkButtonClass}
        type='button'
        onClick={e => {
          e.stopPropagation()
          onFlightDetails?.()
        }}
      >
        <Typography
          color={linkColor ? undefined : 'link'}
          componentNode='span'
          style={linkColor ? { color: linkColor } : undefined}
          variant='L3'
        >
          {detailsLabel}
        </Typography>
        {withChevron && (
          <Container className='flex flex-middle' style={{ color }}>
            <ChevronRight height={16} width={16} />
          </Container>
        )}
      </Container>
    )
  }

  if (variant === 'select') {
    return (
      <Button
        className='flex-no-shrink'
        color='secondary'
        disabled={disabled}
        size='small'
        style={{ height: 40, minWidth: 124, width: 124 }}
        variant='outline'
        onClick={onSelect}
      >
        Select
      </Button>
    )
  }

  if (variant === 'continue') {
    return (
      <Button
        className='flex-no-shrink'
        color='secondary'
        disabled={disabled}
        size={size}
        style={{ height: size === 'medium' ? 48 : 40, minWidth: 124, width: 124 }}
        variant='contained'
        onClick={onContinue}
      >
        Continue
      </Button>
    )
  }

  return (
    <Button
      className='flex-no-shrink'
      color='secondary'
      disabled={disabled}
      size={size}
      style={{ height: size === 'medium' ? 48 : 40, minWidth: 124, width: 124 }}
      variant='contained'
      onClick={onBook}
    >
      Book
    </Button>
  )
}

export default TupleActions
